import {
    customColumnProps,
    DynamicTable,
} from "@maherunlocker/custom-react-table";
import React from "react";
import { useTranslation } from "react-i18next/";
import { useSnapshot } from "valtio";
import { ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";

import {
    store,
    setIsEdited,
    setModify,
    setIsActionsClicked,
    setActions,
    setValidationAction,
} from "./store";
import { setDeliveryCity } from "../../store";

import CustomIcons from "./CustomIcons";
import CustomSideFilter from "./CustomSideFilter";
import CityForm from "./CityForm";

import { getPathAuthorization } from "@components/VerticalLayout";
import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import { ConfirmationUpdatingDataMessageModal } from "@components/Common/ConfirmationUpdatingDataMessageModal";
import { useCallbackPrompt } from "@hooks/useCallbackPrompt";
import { useSelector } from "react-redux";

export default function City({
    dataLivraison,
    listCode,
    data,
    setData,
    selectedRowShops,
}: any) {
    const { t } = useTranslation();
    const location = useLocation();
    const authorizationList = useSelector(
        (state: any) => state.global.infoUser.profileAuthorization
    );
    setModify(
        getPathAuthorization(location.pathname, authorizationList).Modifie
    );
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const [selectedRows, setSelectedRows] = React.useState<any>({});
    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );

    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const [
        isInInitializationModalOpened,
        setIsInInitializationModalOpened,
    ] = React.useState<boolean>(false);
    const [
        isAddNewDeviseButtonClicked,
        setIsAddNewDeviseButtonClicked,
    ] = React.useState(false);

    const {
        isActionsClicked,
        isEdited,
        actions,
        validationAction,
    } = useSnapshot(store);
    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
        isEdited
    );
    const [isAddCity, setIsAddCity] = React.useState(false);

    let schema: any = useSelector(
        (state: any) => state.global.entityDetails.franchise_schema
    );
    let listTva: any[];
    function list() {
        let list: any[] = [];
        for (let el of selectedRowShops[0]["list Of VatRate"]) {
            list.push(el.value);
        }
        return list;
    }
    listTva = selectedRowShops[0] ? list() : [];
    React.useEffect(() => {
        setActions(confirmNavigation);
        setIsActionsClicked(showPrompt as boolean);
        setValidationAction(cancelNavigation);
    }, [showPrompt, confirmNavigation, cancelNavigation]);

    const urlApi = `${process.env.REACT_APP_API_V2_URL}/settings/list/city/c&c?schema=${schema}&shopId=${selectedRowShops[0].id_boutique_order}`;

    let arrayOfCustomColumns: customColumnProps[] = [
        {
            indexOFColumn: 999,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIcons
                    e={e}
                    setSelectedRows={setSelectedRows}
                    setIsAddCity={setIsAddCity}
                    isAddCity={isAddCity}
                    selectedRowShops={selectedRowShops}
                    setDataIsUpdated={setDataIsUpdated}
                    dataLivraison={dataLivraison}
                />
            ),
            disableFilter: false,
        },
        {
            indexOFColumn: 3,
            columnName: t("Tva"),
            customJsx: (e: any) => {
                return (
                    <span className="preview-text">
                        {listTva.includes(`${e.selectedRow[t("Tva")]}`)
                            ? `${e.selectedRow[t("Tva")]}`
                            : "0"}
                    </span>
                );
            },
        },
    ];
    React.useEffect(() => {
        setDeliveryCity(data.data ? data.data : []);
    }, [data]);

    React.useEffect(() => {
        if (i18nextLng === "fr" || i18nextLng === "en") {
            setDataIsUpdated(true);
        }
    }, [i18nextLng]);
    return (
        <React.Fragment>
            <ToastContainer limit={1} />
            <div
                style={{
                    display: "grid",
                    minHeight: "350px",
                    gridTemplateColumns: isAddCity ? "2fr 1fr " : "auto",
                    gridColumnGap: "4px",
                    border: 0,
                }}
            >
                <DynamicTable
                    url={urlApi}
                    showFilter
                    canSelect={true}
                    setData={setData}
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={filterActive}
                    actionColumn={() => <></>}
                    arrayOfCustomColumns={arrayOfCustomColumns}
                    requestHeader={{ "Accept-Language": i18nextLng }}
                    customJsxSideFilterButton={
                        <CustomSideFilter
                            setIsAddCity={setIsAddCity}
                            isAddCity={isAddCity}
                            setLocalFilterActive={setLocalFilterActive}
                            setSelectedRows={setSelectedRows}
                            setIsInInitializationModalOpened={
                                setIsInInitializationModalOpened
                            }
                            isEdited={isEdited}
                            selectedRows={selectedRows}
                        />
                    }
                    showGlobalFilter
                    canExpand={false}
                    elevationTable={1}
                    minHeight={"460px"}
                    maxHeight={"460px"}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                    setSelectedRows={setSelectedRows}
                    name="Choice"
                />
                {isAddCity ? (
                    <CityForm
                        isAddCity={isAddCity}
                        setIsAddCity={setIsAddCity!}
                        setDataIsUpdated={setDataIsUpdated}
                        setLocalFilterActive={setLocalFilterActive}
                        isAddNewDeviseButtonClicked={
                            isAddNewDeviseButtonClicked
                        }
                        selectedRows={selectedRows}
                        setSelectedRows={setSelectedRows}
                        selectedRowShops={selectedRowShops}
                        list={listTva}
                        dataLivraison={dataLivraison}
                        listCode={listCode}
                    />
                ) : null}
                {isActionsClicked === true ? (
                    <ConfirmationUpdatingDataMessageModal
                        isModalOpened={isActionsClicked}
                        setIsModalOpened={setIsActionsClicked}
                        validationAction={validationAction}
                        actions={actions}
                        setIsEdited={setIsEdited}
                    />
                ) : null}
                {isInInitializationModalOpened === true ? (
                    <ConfirmationInitializationMessage
                        isModalOpened={isInInitializationModalOpened}
                        setIsModalOpened={setIsInInitializationModalOpened}
                        setIsClicked={setIsAddNewDeviseButtonClicked}
                        isClicked={isAddNewDeviseButtonClicked}
                        setIsEdited={setIsEdited}
                    />
                ) : null}
            </div>
        </React.Fragment>
    );
}
